import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import Select from "react-select";
import queryString from "query-string";
import moment from "moment";

const SITUACAO_PENDENTE = "0";
const SITUACAO_FINALIZADO = "1";
const SITUACAO_CANCELADO = "2";
const SITUACAO_EM_ATENDIMENTO = "3";

const TIPO_PEDIDO = 0;
const TIPO_DEVOLUCAO = 1;

export default class PedidoDevolucaoMaterialNovo extends Component {
  constructor(props) {
    super(props);
    this.notificar = this.notificar.bind(this);
    this.onChangeInput = this.onChangeInput.bind(this);
    this.cadastrarPedidoMaterial = this.cadastrarPedidoMaterial.bind(this);
    this.validarPedidoMaterial = this.validarPedidoMaterial.bind(this);
    this.buscarPedidoMaterial = this.buscarPedidoMaterial.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.loadUsuarios = this.loadUsuarios.bind(this);
    this.loadObras = this.loadObras.bind(this);
    this.loadUnidadesMedida = this.loadUnidadesMedida.bind(this);
    this.loadLogsRecentes = this.loadLogsRecentes.bind(this);

    this.state = {
      tipoPedido: this.props.tipoPedido, //0 = pedido, 1 = devolucao
      action: "CADASTRAR", //CADASTRAR ou EDITAR
      _id: null,
      desc: "",
      quantidade: "0",
      um: null,
      obra: null,
      usuario: null,
      usuarios: [],
      obras: [],
      errors: {
        desc: false,
        quantidade: false,
        obra: false,
        usuario: false,
        obs: false,
      },
      situacao: "0", //SOMENTE NA EDICAO
      obs: "",
      obsCancelamento: "",
      situacaoAtual: "0",
      unidadesMedida: [],
      isSaving: false,
      tipoAbertura: 0,
      codEmbarque: null,
      logs: [],
      abaAtiva: "dados",
    };
  }

  async componentDidMount() {
    await this.initPage();
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      await this.initPage();
    }
  }

  async initPage() {
    const userLogado = JSON.parse(localStorage.getItem("usuario"));
    if (userLogado.nivel === "4") {
      return this.props.history.push("/nao-conformidades");
    }
    if (userLogado.nivel === "5") {
      return this.props.history.push("/despesas");
    }
    let id = queryString.parse(this.props.location.search).id;
    let action = "CADASTRAR";

    if (id !== undefined && id !== null && id !== "") {
      await this.buscarPedidoMaterial(id);
      action = "EDITAR";
    } else {
      this.setState({
        action: "CADASTRAR",
        _id: null,
        desc: "",
        quantidade: "0",
        um: null,
        obra: null,
        usuario: null,
        situacao: "0",
        obs: "",
        obsCancelamento: "",
        situacaoAtual: "0",
        tipoAbertura: 0,
        codEmbarque: null,
        logs: [],
        abaAtiva: "dados",
      });
    }

    this.setState({ action }, async () => {
      let promises = [
        this.loadUsuarios(),
        this.loadObras(),
        this.loadUnidadesMedida(),
      ];
      if (id !== undefined && id !== null && id !== "") {
        promises.push(this.loadLogsRecentes(id));
      }
      await Promise.all(promises);
    });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  onChangeInput(tipo, value) {
    this.setState({ [tipo]: value }, () => {});
  }

  validarPedidoMaterial() {
    let errors = this.state.errors;
    let valido = true;

    if (this.state.desc === "") {
      errors.desc = true;
      valido = false;
    } else {
      errors.desc = false;
    }
    if (this.state.quantidade === "" || this.state.quantidade === "0") {
      errors.quantidade = true;
      valido = false;
    } else {
      errors.quantidade = false;
    }

    if (this.state.obra === null) {
      errors.obra = true;
      valido = false;
    } else {
      errors.obra = false;
    }

    if (this.state.usuario === null) {
      errors.usuario = true;
      valido = false;
    } else {
      errors.usuario = false;
    }

    if (
      this.state.situacao === SITUACAO_FINALIZADO ||
      this.state.situacao === SITUACAO_EM_ATENDIMENTO
    ) {
      if (this.state.obs === "") {
        errors.obs = true;
        valido = false;
      } else {
        errors.obs = false;
      }
    }

    this.setState({ errors });
    return valido;
  }

  async cadastrarPedidoMaterial() {
    if (this.state.isSaving) {
      return false;
    }

    this.setState({ isSaving: true }, async () => {
      if (!this.validarPedidoMaterial()) {
        this.notificar("warning", "Favor preencher todos os dados!");
        this.setState({ isSaving: false });
        return false;
      }

      let acaoPagina = this.state._id === null ? "cadastrar" : "editar";

      let pedidoMaterialNovo = {
        desc: this.state.desc,
        quantidade: this.state.quantidade,
        um: this.state.um,
        obra: this.state.obra,
        usuario: this.state.usuario,
        situacao: this.state.situacao,
        obs: this.state.obs,
        obsCancelamento: this.state.obsCancelamento,
        tipoPedido: this.state.tipoPedido,
        tipoAbertura: this.state.tipoAbertura,
        codEmbarque: this.state.codEmbarque,
      };

      if (this.state.situacao === SITUACAO_PENDENTE && this.state.obs !== "") {
        pedidoMaterialNovo.situacao = SITUACAO_EM_ATENDIMENTO;
      }

      let urlAtualizar = `${this.props.getBaseUrlApi()}/retaguarda/pedidos-material`;

      if (acaoPagina === "editar") {
        pedidoMaterialNovo._id = this.state._id;
        urlAtualizar = `${this.props.getBaseUrlApi()}/retaguarda/pedidos-material/${
          this.state._id
        }`;
      }

      const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));

      await axios
        .post(
          urlAtualizar,
          {
            pedidoMaterial: pedidoMaterialNovo,
            usuarioLogado: usuarioLogado
              ? {
                  _id: usuarioLogado._id,
                  _rev: usuarioLogado._rev,
                  desc: usuarioLogado.desc,
                  login: usuarioLogado.login,
                }
              : null,
          },
          this.props.parameters()
        )
        .then((response) => {
          if (acaoPagina === "cadastrar") {
            if (this.state.tipoPedido === TIPO_PEDIDO) {
              this.notificar(
                "success",
                "Pedido de material cadastrado com sucesso!"
              );
            } else {
              this.notificar(
                "success",
                "Devolução de material cadastrada com sucesso!"
              );
            }
          } else {
            if (this.state.tipoPedido === TIPO_PEDIDO) {
              this.notificar(
                "success",
                "Pedido de material editado com sucesso!"
              );
            } else {
              this.notificar(
                "success",
                "Devolução de material editada com sucesso!"
              );
            }
          }

          setTimeout(() => {
            if (this.state.tipoPedido === TIPO_PEDIDO) {
              this.props.history.push("/pedidos-material");
            } else {
              this.props.history.push("/devolucoes-material");
            }
          }, 1000);
        })
        .catch((error) => {
          this.notificar("warning", error.response ? error.response.data.erro : "Erro ao salvar!");
          this.setState({ isSaving: false });
        });
    });
  }

  async buscarPedidoMaterial(id) {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/retaguarda/pedidos-material/${id}`,
        this.props.parameters()
      )
      .then((response) => {
        const pedidoMaterial = response.data.pedidoMaterial;

        if (pedidoMaterial === null) {
          if (this.state.tipoPedido === TIPO_PEDIDO) {
            this.props.history.push("/pedidos-material");
          } else {
            this.props.history.push("/devolucoes-material");
          }
          return false;
        }

        let tipoAbertura = this.state.tipoAbertura;
        let codEmbarque = this.state.codEmbarque;

        if (pedidoMaterial.tipoAbertura !== undefined) {
          tipoAbertura = pedidoMaterial.tipoAbertura;
        }

        if (pedidoMaterial.codEmbarque !== undefined) {
          codEmbarque = pedidoMaterial.codEmbarque;
        }

        let logs = Array.isArray(pedidoMaterial.logs) ? [...pedidoMaterial.logs] : [];
        logs = logs.sort((a, b) => new Date(b.dtCadastro) - new Date(a.dtCadastro));

        this.setState({
          _id: pedidoMaterial._id,
          desc: pedidoMaterial.desc,
          quantidade: pedidoMaterial.quantidade,
          um: pedidoMaterial.um,
          obra: pedidoMaterial.obra,
          usuario: pedidoMaterial.usuario,
          situacao: pedidoMaterial.situacao,
          obs: pedidoMaterial.obs,
          obsCancelamento: pedidoMaterial.obsCancelamento || "",
          situacaoAtual: pedidoMaterial.situacao,
          tipoAbertura,
          codEmbarque,
          logs,
        });
      });
  }

  handleFocus(e) {
    e.target.select();
  }

  async loadUsuarios() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/retaguarda/usuarios`,
        this.props.parameters()
      )
      .then((response) => {
        let usuarios = response.data.usuarios || [];

        for (let item of usuarios) {
          item.label = item.desc;
          item.value = item._id;
        }

        let usuario = null;

        if (this.state.usuario !== null) {
          let usuarioFind = usuarios.find(
            (it) => it._id === this.state.usuario._id
          );
          if (usuarioFind !== undefined) {
            usuario = usuarioFind;
          }
        }

        this.setState({ usuarios, usuario });
      });
  }

  async loadObras() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/retaguarda/lista-obras`,
        {},
        this.props.parameters()
      )
      .then((response) => {
        let obras = response.data.obras || [];

        let obra = null;

        for (let item of obras) {
          item.label = `${item.cod.toString().padStart(4, "0")} - ${item.desc}`;
          item.value = item._id;
        }

        if (this.state.obra !== null) {
          let obraFind = obras.find((it) => it._id === this.state.obra._id);
          if (obraFind !== undefined) {
            obra = obraFind;
          }
        }

        this.setState({ obras, obra });
      });
  }

  async loadUnidadesMedida() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/retaguarda/lista-unidades-medida`,
        { filtro: { status: "A" } },
        this.props.parameters()
      )
      .then((response) => {
        let unidadesMedida = response.data.unidadesMedida || [];

        for (let item of unidadesMedida) {
          item.label = `${item.desc} - ${item.obs}`;
          item.value = item._id;
        }

        this.setState({ unidadesMedida });
      });
  }

  async loadLogsRecentes(idCustom) {
    let id = idCustom || this.state._id || queryString.parse(this.props.location.search).id;
    if (!id) {
      this.setState({ logs: [] });
      return;
    }
    let payload = {
      tipoPedido: this.state.tipoPedido,
      idPedido: id,
    };

    await axios
      .post(
        `${this.props.getBaseUrlApi()}/retaguarda/logs-pedidos-material`,
        payload,
        this.props.parameters()
      )
      .then((response) => {
        let logs = response.data.logs || [];
        this.setState({ logs });
      });
  }

  render() {
    const InputRequired = () => {
      return <span className="required-icone">*</span>;
    };

    const idParam = queryString.parse(this.props.location.search).id;
    const isEdicao = Boolean(idParam && this.state._id);

    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar
            title={`${
              this.state.tipoPedido === TIPO_PEDIDO ? "Pedido" : "Devolução"
            } de Material / ${
              this.state.action === "CADASTRAR" ? "Novo" : "Editar"
            }`}
          />
          <div className="container-fluid page-body-wrapper">
            <SideBar
              itemActive={
                this.state.tipoPedido === TIPO_PEDIDO
                  ? "pedidosMaterial"
                  : "devolucoesMaterial"
              }
            />
            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body5 dashboard-tabs p-0">
                        {isEdicao && (
                          <ul className="nav nav-tabs px-3 pt-3" role="tablist" style={{ borderBottom: "1px solid #dee2e6" }}>
                            <li className="nav-item">
                              <button
                                type="button"
                                className={`nav-link ${this.state.abaAtiva === "dados" ? "active font-weight-bold" : ""}`}
                                onClick={() => this.setState({ abaAtiva: "dados" })}
                                style={{
                                  cursor: "pointer",
                                  border: this.state.abaAtiva === "dados" ? "1px solid #dee2e6" : "1px solid transparent",
                                  borderBottom: this.state.abaAtiva === "dados" ? "1px solid #fff" : "none",
                                  background: this.state.abaAtiva === "dados" ? "#fff" : "transparent",
                                  boxShadow: this.state.abaAtiva === "dados" ? "0 -2px 6px rgba(0,0,0,0.08)" : "none",
                                  padding: "10px 20px",
                                  borderRadius: "4px 4px 0 0",
                                  color: this.state.abaAtiva === "dados" ? "#333" : "#6c757d",
                                }}
                              >
                                <i className="fa fa-edit mr-2"></i> Dados
                              </button>
                            </li>
                            <li className="nav-item">
                              <button
                                type="button"
                                className={`nav-link ${this.state.abaAtiva === "logs" ? "active font-weight-bold" : ""}`}
                                onClick={() => this.setState({ abaAtiva: "logs" }, () => this.loadLogsRecentes(idParam))}
                                style={{
                                  cursor: "pointer",
                                  border: this.state.abaAtiva === "logs" ? "1px solid #dee2e6" : "1px solid transparent",
                                  borderBottom: this.state.abaAtiva === "logs" ? "1px solid #fff" : "none",
                                  background: this.state.abaAtiva === "logs" ? "#fff" : "transparent",
                                  boxShadow: this.state.abaAtiva === "logs" ? "0 -2px 6px rgba(0,0,0,0.08)" : "none",
                                  padding: "10px 20px",
                                  borderRadius: "4px 4px 0 0",
                                  color: this.state.abaAtiva === "logs" ? "#333" : "#6c757d",
                                }}
                              >
                                <i className="fa fa-history mr-2"></i> Logs
                              </button>
                            </li>
                          </ul>
                        )}

                        <div className={`tab-content ${isEdicao ? "py-3 px-3" : "p-3"}`}>
                          {(!isEdicao || this.state.abaAtiva === "dados") && (
                            <div
                              className="tab-pane fade show active"
                              id="overview"
                              role="tabpanel"
                              aria-labelledby="overview-tab"
                            >
                              <div className="d-flex flex-wrap justify-content-xl-between">
                                <div style={{ float: "left", width: "100%" }}>
                                  <div className="row">
                                    <div className="col-md-3 pd-veiculo2">
                                      <div className="form-group form-group-chegoo" style={{ position: "relative" }}>
                                        <label>Usuário&nbsp;<InputRequired /></label>
                                        <Select
                                          value={this.state.usuario}
                                          onChange={(item) => this.onChangeInput("usuario", item)}
                                          options={this.state.usuarios}
                                          placeholder="Selecione o usuário"
                                          className={`${this.state.errors.usuario ? "select-error" : ""} required-chegoo`}
                                          isDisabled={this.state.situacao === "1" || this.state.situacao === "2"}
                                          styles={{
                                            control: (baseStyles) => ({
                                              ...baseStyles,
                                              fontSize: "14px",
                                              height: "35px",
                                              minHeight: "35px",
                                              backgroundColor: "#fffef6",
                                            }),
                                            menu: (baseStyles) => ({
                                              ...baseStyles,
                                              fontSize: "14px",
                                            }),
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-md-3 pd-veiculo">
                                      <div className="form-group form-group-chegoo" style={{ position: "relative" }}>
                                        <label>Obra&nbsp;<InputRequired /></label>
                                        <Select
                                          value={this.state.obra}
                                          onChange={(item) => this.onChangeInput("obra", item)}
                                          options={this.state.obras}
                                          placeholder="Selecione a obra"
                                          className={`${this.state.errors.obra ? "select-error" : ""} required-chegoo`}
                                          styles={{
                                            control: (baseStyles) => ({
                                              ...baseStyles,
                                              fontSize: "14px",
                                              height: "35px",
                                              minHeight: "35px",
                                              backgroundColor: "#fffef6",
                                            }),
                                            menu: (baseStyles) => ({
                                              ...baseStyles,
                                              fontSize: "14px",
                                            }),
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-md-4 pd-veiculo3">
                                      <div className="form-group form-group-chegoo">
                                        <label>U.M</label>
                                        <Select
                                          value={this.state.um}
                                          onChange={(item) => this.onChangeInput("um", item)}
                                          options={this.state.unidadesMedida}
                                          placeholder="Selecione a U.M"
                                          styles={{
                                            control: (baseStyles) => ({
                                              ...baseStyles,
                                              fontSize: "14px",
                                              height: "35px",
                                              minHeight: "35px",
                                              backgroundColor: "#fffef6",
                                            }),
                                            menu: (baseStyles) => ({
                                              ...baseStyles,
                                              fontSize: "14px",
                                            }),
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-md-6 pd-veiculo2">
                                      <div className="form-group form-group-chegoo">
                                        <label>Item&nbsp;<InputRequired /></label>
                                        <textarea
                                          className="form-control font-size-14 form-control-chegoo required-chegoo text-area-form"
                                          rows={8}
                                          value={this.state.desc}
                                          onChange={(e) => this.onChangeInput("desc", e.target.value)}
                                          ref={(node) => {
                                            if (node) {
                                              if (this.state.errors.desc) {
                                                node.style.setProperty("border-color", "red", "important");
                                              } else {
                                                node.style.setProperty("border-color", "#ced4da", "important");
                                              }
                                            }
                                          }}
                                        ></textarea>
                                      </div>
                                    </div>

                                    <div className="col-md-2 pd-veiculo3">
                                      <div className="form-group form-group-chegoo">
                                        <label>Quantidade&nbsp;<InputRequired /></label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={this.state.quantidade}
                                          onChange={(e) => this.onChangeInput("quantidade", e.target.value)}
                                          onFocus={this.handleFocus}
                                          ref={(node) => {
                                            if (node) {
                                              if (this.state.errors.quantidade) {
                                                node.style.setProperty("border-color", "red", "important");
                                              } else {
                                                node.style.setProperty("border-color", "#ced4da", "important");
                                              }
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>

                                    {this.state._id !== null && (
                                      <div className="col-md-3 pd-veiculo3">
                                        <div className="form-group form-group-chegoo">
                                          <label>Situação&nbsp;<InputRequired /></label>
                                          <select
                                            className="form-control form-control-chegoo font-size-14"
                                            value={this.state.situacao}
                                            onChange={(e) => this.onChangeInput("situacao", e.target.value)}
                                          >
                                            <option value="0">Pendente</option>
                                            <option value="3">Em Atendimento</option>
                                            <option value="1">Finalizado</option>
                                            <option value="2">Cancelado</option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {this.state.situacao === SITUACAO_CANCELADO && this.state._id !== null && (
                                    <div className="row">
                                      <div className="col-md-6 pd-veiculo2">
                                        <div className="form-group form-group-chegoo">
                                          <label>Obs Cancelamento</label>
                                          <textarea
                                            className="form-control form-control-chegoo font-size-14 textarea-registroo"
                                            value={this.state.obsCancelamento}
                                            onChange={(e) => this.onChangeInput("obsCancelamento", e.target.value)}
                                            rows="4"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {this.state.situacao !== SITUACAO_CANCELADO && this.state._id !== null && (
                                    <div className="row">
                                      <div className="col-md-6 pd-veiculo2">
                                        <div className="form-group form-group-chegoo">
                                          <label>Obs Resolução&nbsp;</label>
                                          <textarea
                                            type="text"
                                            className="form-control form-control-chegoo font-size-14 textarea-registroo"
                                            value={this.state.obs}
                                            onChange={(e) => this.onChangeInput("obs", e.target.value)}
                                            ref={(node) => {
                                              if (node) {
                                                if (this.state.errors.obs) {
                                                  node.style.setProperty("border-color", "red", "important");
                                                } else {
                                                  node.style.setProperty("border-color", "#ced4da", "important");
                                                }
                                              }
                                            }}
                                            rows="4"
                                          />
                                        </div>
                                      </div>
                                      {this.state.tipoAbertura === 1 && (
                                        <div className="col-md-6 pd-veiculo2">
                                          <div className="alert alert-warning" role="alert" style={{ marginTop: "23px" }}>
                                            {this.state.tipoPedido === TIPO_PEDIDO ? "Este pedido" : "Esta devolução"} de material foi {this.state.tipoPedido === TIPO_PEDIDO ? "aberto" : "aberta"} automaticamente após divergência na conferência de itens, cód do embarque: {this.state.codEmbarque}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}

                                  <div className="row">
                                    <div className="col-md-2 pd-veiculo2">
                                      <div className="form-group form-group-chegoo2">
                                        <button
                                          className="btn btn-success btn-app-verde"
                                          onClick={() => this.cadastrarPedidoMaterial()}
                                          disabled={this.state.situacaoAtual === "2"}
                                        >
                                          {this.state.isSaving ? "Salvando..." : "Salvar"}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {isEdicao && this.state.abaAtiva === "logs" && (
                            <div className="p-3">
                              <h6 style={{ fontWeight: "bold", marginBottom: "15px", color: "#343a40", display: "flex", alignItems: "center" }}>
                                <i className="fa fa-history" style={{ marginRight: "8px", color: "#198754" }}></i>
                                Histórico de Alterações
                              </h6>

                              {this.state.logs.length === 0 ? (
                                <div className="alert alert-light text-center py-4" role="alert" style={{ border: "1px dashed #ced4da" }}>
                                  <i className="fa fa-info-circle fa-2x text-muted mb-2 d-block"></i>
                                  Nenhum registro de log encontrado para este pedido.
                                </div>
                              ) : (
                                <div className="timeline-wrapper">
                                  {this.state.logs.map((log, index) => {
                                    let borderColor = "#ffc107";
                                    let badgeBg = "#fff3cd";
                                    let badgeColor = "#856404";
                                    let actionText = "Edição";

                                    if (log.acao === "FINALIZACAO") {
                                      borderColor = "#198754";
                                      badgeBg = "#d1e7dd";
                                      badgeColor = "#0f5132";
                                      actionText = "Aprovado / Finalizado";
                                    } else if (log.acao === "CANCELAMENTO") {
                                      borderColor = "#dc3545";
                                      badgeBg = "#f8d7da";
                                      badgeColor = "#842029";
                                      actionText = "Cancelado";
                                    } else if (log.acao === "CRIACAO") {
                                      borderColor = "#0d6efd";
                                      badgeBg = "#cfe2ff";
                                      badgeColor = "#084298";
                                      actionText = "Cadastro";
                                    }

                                    const nomeSolicitante = (log.solicitante && log.solicitante.desc)
                                      ? log.solicitante.desc
                                      : (this.state.usuario && this.state.usuario.desc ? this.state.usuario.desc : "");

                                    const nomeObra = (log.obra && log.obra.desc)
                                      ? `${log.obra.cod ? log.obra.cod + " - " : ""}${log.obra.desc}`
                                      : (this.state.obra && this.state.obra.desc ? this.state.obra.desc : "");

                                    const itemDesc = log.item || this.state.desc || "";
                                    const qtdDesc = log.quantidade !== undefined ? log.quantidade : this.state.quantidade;
                                    const umDesc = typeof log.um === "object" ? (log.um.desc || log.um.label || "") : (log.um || "");

                                    return (
                                      <div
                                        key={log._id || index}
                                        style={{
                                          display: "flex",
                                          marginBottom: "16px",
                                          borderLeft: `4px solid ${borderColor}`,
                                          paddingLeft: "15px",
                                          backgroundColor: "#f8f9fa",
                                          borderRadius: "0 6px 6px 0",
                                          padding: "12px 16px",
                                          boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                                        }}
                                      >
                                        <div style={{ flex: 1 }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              marginBottom: "6px",
                                              flexWrap: "wrap",
                                              gap: "6px",
                                            }}
                                          >
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                                              <span style={{ fontWeight: "bold", color: "#212529", fontSize: "14px" }}>
                                                <i className="fa fa-user-circle-o text-secondary mr-1"></i>
                                                {log.usuario ? log.usuario.desc : "Usuário"}
                                              </span>
                                              <span
                                                style={{
                                                  fontSize: "11px",
                                                  fontWeight: "600",
                                                  backgroundColor: badgeBg,
                                                  color: badgeColor,
                                                  padding: "2px 8px",
                                                  borderRadius: "8px",
                                                }}
                                              >
                                                {actionText}
                                              </span>
                                            </div>
                                            <span
                                              style={{
                                                fontSize: "12px",
                                                color: "#6c757d",
                                                backgroundColor: "#e9ecef",
                                                padding: "3px 10px",
                                                borderRadius: "12px",
                                              }}
                                            >
                                              <i className="fa fa-calendar mr-1"></i>
                                              {moment(log.dtCadastro).format("DD/MM/YYYY [às] HH:mm:ss")}
                                            </span>
                                          </div>

                                          <p style={{ margin: "0 0 8px 0", fontSize: "13px", color: "#495057" }}>
                                            {log.descricaoLog || (log.acao === "CRIACAO" ? "Cadastrou o pedido de material" : log.acao === "FINALIZACAO" ? "Aprovou e finalizou o pedido" : log.acao === "CANCELAMENTO" ? "Cancelou o pedido" : "Alterou o pedido")}
                                          </p>

                                          {/* Bloco de detalhes: Item, Solicitante, Obra */}
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              color: "#495057",
                                              backgroundColor: "#ffffff",
                                              padding: "8px 12px",
                                              borderRadius: "5px",
                                              border: "1px solid #e9ecef",
                                              marginBottom: (log.alteracoes && log.alteracoes.length > 0) ? "8px" : "0",
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: "12px",
                                            }}
                                          >
                                            {itemDesc && (
                                              <div>
                                                <i className="fa fa-cube text-primary mr-1"></i>
                                                <strong>Item:</strong> {itemDesc} {qtdDesc ? `(${qtdDesc} ${umDesc})` : ""}
                                              </div>
                                            )}
                                            {nomeSolicitante && (
                                              <div>
                                                <i className="fa fa-user text-info mr-1"></i>
                                                <strong>Solicitante:</strong> {nomeSolicitante}
                                              </div>
                                            )}
                                            {nomeObra && (
                                              <div>
                                                <i className="fa fa-building text-warning mr-1"></i>
                                                <strong>Obra:</strong> {nomeObra}
                                              </div>
                                            )}
                                          </div>

                                          {log.alteracoes && log.alteracoes.length > 0 && (
                                            <div style={{ marginTop: "6px" }}>
                                              <strong style={{ fontSize: "12px", color: "#495057" }}>Detalhes da ação:</strong>
                                              <ul style={{ margin: "3px 0 0 0", paddingLeft: "20px", fontSize: "12px", color: "#0d6efd" }}>
                                                {log.alteracoes.map((alt, aIdx) => (
                                                  <li key={aIdx} style={{ marginBottom: "2px" }}>
                                                    {alt}
                                                  </li>
                                                ))}
                                              </ul>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
